/**
 * Small stroke icons for the shell. Inline SVG with currentColor, so they follow whatever text
 * colour the surrounding token sets in light and dark mode. Always decorative: the text beside
 * them (or an aria-label on the button) carries the meaning.
 */
const paths: Record<string, string> = {
  home: 'M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z',
  play: 'M5 4h14v16H5zM9 8l6 4-6 4z',
  skills: 'M12 3l2.4 5 5.6.8-4 3.9.9 5.5L12 15.6 7.1 18.2l.9-5.5-4-3.9 5.6-.8z',
  file: 'M7 3h7l5 5v13H7zM14 3v5h5M9.5 13h7M9.5 17h7',
  usage: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  approvals: 'M9 12l2 2 4-4M12 3l7 3v6c0 4.5-3 7.6-7 9-4-1.4-7-4.5-7-9V6z',
  callers: 'M16 19v-1a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v1M9 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6M22 19v-1a4 4 0 0 0-3-3.9M16 4.1a3 3 0 0 1 0 5.8',
  models: 'M12 2l8.5 5v10L12 22l-8.5-5V7zM12 22V12M20.5 7 12 12 3.5 7',
  suppliers: 'M9 2v6M15 2v6M7 8h10v4a5 5 0 0 1-10 0zM12 17v5',
  mcp: 'M4 4h16v6H4zM4 14h16v6H4zM8 7h.01M8 17h.01',
  gateway: 'M3 3v18h18M7 15l4-4 3 3 5-6',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM21 21l-5-5',
  help: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6V14M12 17.5h.01',
  menu: 'M4 6h16M4 12h16M4 18h16',
  close: 'M6 6l12 12M18 6 6 18',
  chevron: 'M9 6l6 6-6 6',
  back: 'M15 6l-6 6 6 6'
};

export type IconName = keyof typeof paths;

export function Icon({ name, size = 18 }: { name: IconName; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d={paths[name]} />
    </svg>
  );
}
